import React, { useState, useEffect, useMemo } from 'react'
import injectStyles from 'react-jss'

import PropTypes from 'prop-types'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/Add'
import { useDispatch } from 'react-redux'

import { Link } from 'react-router-dom'
import { getOnboardingTimesByCityId, removeOnboardingTime } from './gql'
import { showReduxModal, hideReduxModal } from '../../../../Reducers/UI/actions'
import styles from './styles'

import { SectionTitle } from '../../../../Components/Section/SectionTitle'

import { LinkDelete } from '../../../../Components/LinkDelete'
import OnboardingTimesAddModal from '../../../../Containers/City/Page/OnboardingTimes/OnboardingTimesAdd'

import CityPage from '../../../../Containers/City/Page'

import AdditionalInfo from '../AdditionalInfo'
import OnboardingQuiz from '../OnboardingQuiz/container/OnboardingQuiz'

import * as CONST from './tableSettings'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import SubmitButton from '../../../../Components/Form/SubmitButton'
import { format24Time } from '../../../../Utils/Formatters/index'
import { convertIntToDay, sortTimesItems } from '../utils'
import SimpleTableTable from '../../../../Components/SimpleTableTable'

const ManageOnboardingTimes = props => {
  const [loadingData, setLoadingData] = useState(false)
  const { cityId, classes, countryCode } = props
  const [onboardingTimesList, setOnboardingTimesList] = useState([])
  const dispatch = useDispatch()

  const isShowedQuiz = countryCode && ['US', 'UK'].includes(countryCode)

  useEffect(() => {
    fetchOnboardingTimes()
  }, [])

  const fetchOnboardingTimes = async () => {
    const data = await getOnboardingTimesByCityId(cityId)
    setOnboardingTimesList(data.data.city.onboardingTimes)
  }
  const handleRemove = async id => {
    setLoadingData(true)

    await removeOnboardingTime(id)
    await fetchOnboardingTimes()
    setLoadingData(false)
  }
  const sortOn = ['day', 'start', 'end', 'type']
  const onboardingTimeMapper = time => {
    const { id, type, day, timeStart, timeStop } = time
    return {
      id,
      'start': format24Time(timeStart),
      'end': format24Time(timeStop),
      'day': convertIntToDay(day),
      'type': type,
      'actions': <LinkDelete onClickHandler={() => handleRemove(id)} />,
    }
  }

  const onboardingTimesTableData = useMemo(() =>
    onboardingTimesList.length > 0
      ? onboardingTimesList.sort(sortTimesItems).map(onboardingTimeMapper)
      : [],
  )

  return (
    <CityPage
      active={props.nav}
      cityId={props.cityId}
      history={props.history}
      match={props.match}
      cityName={props.cityName}
    >
      <div className={classes.titleSection}>
        <StyledIconButton
          href={props.match.url.replace('manage-onboarding-times', 'edit')}
          className="link-edit-main"
        >
          <EditIcon />
        </StyledIconButton>
        <SectionTitle className="title">Manage Onboarding Times</SectionTitle>
        <StyledIconButton
          className="add-new-time"
          onClick={() =>
            dispatch(
              showReduxModal({
                title: 'Add Onboarding Time',
                hideButtons: true,
                children: (
                  <OnboardingTimesAddModal
                    closeModal={() => dispatch(hideReduxModal())}
                    fetchOnboardingTimes={fetchOnboardingTimes}
                    onboardingTimesList={
                      onboardingTimesList.length > 0 && onboardingTimesList
                    }
                    cityId={cityId}
                    cypress_id="add-onb-time-modal"
                  />
                ),
              }),
            )
          }
          cypress_id="manage-onb-times-add-button"
        >
          <AddIcon />
        </StyledIconButton>
      </div>

      <div className={classes.tableWrapper}>
        {onboardingTimesList.length > 0 && !loadingData && (
          <SimpleTableTable
            header={CONST.ONBOARDING_TIMES_TABLE_THEAD_VALUES}
            data={onboardingTimesTableData}
            sortOn={sortOn}
            cypress_id="onboarding-times-table"
          />
        )}
        <Link
          to="ambassadors"
          style={{ textDecoration: 'none' }}
          className={classes.goToAmbassadorsButton}
        >
          <SubmitButton value="Go to Ambassadors" />
        </Link>
      </div>
      <OnboardingQuiz cityId={cityId} isShowedQuiz={isShowedQuiz} />
      <AdditionalInfo cityId={cityId} />
    </CityPage>
  )
}

ManageOnboardingTimes.propTypes = {
  getOnboardingTimesByCityId: PropTypes.func.isRequired,
  savePickupTimesList: PropTypes.func.isRequired,
  removeOnboardingTime: PropTypes.func.isRequired,
  pickupTimesList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      day: PropTypes.string.isRequired,
      timeStart: PropTypes.string,
      timeStop: PropTypes.string,
    }),
  ),
}

export default injectStyles(styles)(ManageOnboardingTimes)
